import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { SupervisorSkill } from './supervisor-skill'
import { supervisorSkillActions } from './supervisor-skill.actions'
import * as fromSupervisorSkill from './supervisor-skill.reducer'
import { SupervisorSkillService } from './supervisor-skill.service'
import { exhaustMap, map } from 'rxjs/operators'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'

@Injectable()
export class SupervisorSkillEffects extends ResourceEffects<SupervisorSkill> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private supervisorSkillService: SupervisorSkillService
  ) {
    super(
      fromSupervisorSkill.FEATURE_NAME,
      supervisorSkillService,
      supervisorSkillActions,
      actions$
    )
  }
}
